// src/assets/themeConfig.ts

export const themes = [
    {
        id: "synthwave",
        name: "Synthwave",
        innerBg: "#e500ff",
        outerRingBg: "#4fffff",
        outerRingProgress: "#e500ff",
        innerBgOpacity: '0.5',
        outerRingBgOpacity: '1',
        outerRingProgressOpacity: '1',
        pillsBg: "#e500ff",
        timer: "#ffffff",
        currentLevelLabel: '#ffffff',
        currentBlinds: "#4fffff",
        currentAnte: "#ffffff",
        nextLevelLabel: '#ffffff',
        nextNumbers: "#ffffff",
        nextAnte: "#4fffff",
        text: "#ffffff",
        accent: "#4fffff",
        bgImage: require("./images/backgrounds/Synthwave.png"),
        alternativeLogo: null,
        themePreview: require('./images/themes/preview/Synthwave.png')
    },
    {
        id: "emergold",
        name: "Emergold",
        innerBg: "#1e1e1c",
        outerRingBg: "#1e1e1c",
        outerRingProgress: "#caab65",
        innerBgOpacity: '1',
        outerRingBgOpacity: '1',
        outerRingProgressOpacity: '1',
        pillsBg: "#1e1e1c",
        timer: "#caab65",
        currentLevelLabel: '#ffffff',
        currentBlinds: "#caab65",
        currentAnte: "#ffffff",
        nextLevelLabel: '#caab65',
        nextNumbers: "#ffffff",
        nextAnte: "#caab65",
        text: "#ffffff",
        accent: "#caab65",
        bgImage: require("./images/backgrounds/Emergold.png"),
        alternativeLogo: null,
        themePreview: require('./images/themes/preview/Emergold.png')
    },
    {
        id: "wildberry",
        name: "Wildberry",
        innerBg: "#ffffff",
        outerRingBg: "#ef7984",
        outerRingProgress: "#ffffff",
        innerBgOpacity: '1',
        outerRingBgOpacity: '1',
        outerRingProgressOpacity: '1',
        pillsBg: "#ffffff",
        timer: "#1b213d",
        currentLevelLabel: '#1b213d',
        currentBlinds: "#ef7974",
        currentAnte: "#1b213d",
        nextLevelLabel: '#ffffff',
        nextNumbers: "#1b213d",
        nextAnte: "#ef7974",
        text: "#1b213d",
        accent: "#ef7974",
        bgImage: require("./images/backgrounds/Wildberry.png"),
        alternativeLogo: null,
        themePreview: require('./images/themes/preview/Wildberry.png')
    },
    {
        id: "grnd",
        name: "GRND on Tour",
        innerBg: "#ffffff",
        outerRingBg: "#ef7a1a",
        outerRingProgress: "#ffffff",
        innerBgOpacity: '1',
        outerRingBgOpacity: '1',
        outerRingProgressOpacity: '1',
        pillsBg: "#ffffff",
        timer: "#41ab34",
        currentLevelLabel: '#41ab34',
        currentBlinds: "#ef7a1a",
        currentAnte: "#41ab34",
        nextLevelLabel: '#ffffff',
        nextNumbers: "#41ab34",
        nextAnte: "#ef7a1a",
        text: "#41ab34",
        accent: "#ef7a1a",
        bgImage: require("./images/backgrounds/GRND_Green.png"),
        alternativeLogo: require("./images/GRND.png"),
        themePreview: require('./images/themes/preview/GRND.png')
    },
    {
        id: "red",
        name: "Red",
        innerBg: "#010101",
        outerRingBg: "#caab65",
        outerRingProgress: "#ffffff",
        innerBgOpacity: '1',
        outerRingBgOpacity: '1',
        outerRingProgressOpacity: '1',
        pillsBg: "#010101",
        timer: "#ffffff",
        currentLevelLabel: '#ffffff',
        currentBlinds: "#caab65",
        currentAnte: "#ffffff",
        nextLevelLabel: '#caab65',
        nextNumbers: "#ffffff",
        nextAnte: "#caab65",
        text: "#ffffff",
        accent: "#caab65",
        bgImage: require("./images/backgrounds/Red.png"),
        alternativeLogo: null,
        themePreview: require('./images/themes/preview/Red.png')
    },
    {
        id: "stellaris",
        name: "Stellaris",
        innerBg: "#562c59",
        outerRingBg: "#c4d050",
        outerRingProgress: "#ffffff",
        innerBgOpacity: '1',
        outerRingBgOpacity: '1',
        outerRingProgressOpacity: '1',
        pillsBg: "#010101",
        timer: "#c4d050",
        currentLevelLabel: '#ffffff',
        currentBlinds: "#c4d050",
        currentAnte: "#ffffff",
        nextLevelLabel: '#ffffff',
        nextNumbers: "#ffffff",
        nextAnte: "#c4d050",
        text: "#ffffff",
        accent: "#c4d050",
        bgImage: require("./images/backgrounds/Stellaris.png"),
        alternativeLogo: null,
        themePreview: require('./images/themes/preview/Stellaris.png')
    },
    {
        id: "pokerlounge",
        name: "Poker Lounge",
        innerBg: "#274841",
        outerRingBg: "#caab65",
        outerRingProgress: "#ffffff",
        innerBgOpacity: '0.5',
        outerRingBgOpacity: '1',
        outerRingProgressOpacity: '1',
        pillsBg: "#274841",
        timer: "#caab65",
        currentLevelLabel: '#ffffff',
        currentBlinds: "#caab65",
        currentAnte: "#ffffff",
        nextLevelLabel: '#ffffff',
        nextNumbers: "#ffffff",
        nextAnte: "#caab65",
        text: "#ffffff",
        accent: "#caab65",
        bgImage: require("./images/backgrounds/Poker_Lounge.png"),
        alternativeLogo: null,
        themePreview: require('./images/themes/preview/Poker_Lounge.png')

    },
] as const;

export type ThemeType = typeof themes[number]["id"];
export const themeIds = themes.map(t => t.id) as ThemeType[];

